<script>
/* eslint-disable */
import * as THREE from 'three';
import CameraControls from "camera-controls";
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';
import {CSS2DRenderer, CSS2DObject} from 'three/addons/renderers/CSS2DRenderer.js';
import {gsap} from "gsap";
import {InteractionManager} from "three.interactive";
import {GUI} from "three/addons/libs/lil-gui.module.min";

import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer.js';
import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass.js';
import {ShaderPass} from 'three/examples/jsm/postprocessing/ShaderPass.js';
import {OutlinePass} from 'three/examples/jsm/postprocessing/OutlinePass.js';
import {FXAAShader, SMAAPass} from "three/addons";
import {GammaCorrectionShader} from "three/addons";


import * as TWEEN from "@tweenjs/tween.js";
import {CubeTextureLoader, PMREMGenerator} from "three";
import {EXRLoader} from "three/addons/loaders/EXRLoader";
import {isProxy, toRaw} from 'vue';

import {useClickedStore} from "@/globalStorage";
import {watch} from "vue";

import PopupComponent from "@/components/ThreeJs/PopupComponent.vue";
import ThreeHeader from "@/components/layout/header/ThreeHeader.vue";
import SidebarOrganizer from "@/components/ThreeJs/SidebarPopup/SidebarOrganizer.vue";
import popupsDe from "@/assets/i18n/de/popups.json";
import popupsEn from "@/assets/i18n/en/popups.json";
import popupsCn from "@/assets/i18n/cn/popups.json";
import popupsTr from "@/assets/i18n/tr/popups.json";
import popupsJa from "@/assets/i18n/ja/popups.json";

import generalTranslate from "@/i18n.js";

CameraControls.install({THREE});
export default {
  components: {
    PopupComponent,
    ThreeHeader,
    SidebarOrganizer
  },
  props: {
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    introClosed: {
      type: Boolean,
      default: false,
    },
    isSmallPopupOpened: {
      type: Object
    },
    controlValue: {},
    isVolumeMuted: {},
  },
  watch: {
    isFormSubmitted(newVal) {
      if (newVal === true) {
        this.showElement = true;
        this.initializeModels(this.formData.avatar);
        this.$nextTick(() => {
          this.initThreeJS();
          this.getAvatar(this.formData.avatar);
          this.mapVisible = true
        });
      }
    },
    introClosed(newVal) {
      this.closeOverlay();
    },
    isSmallPopupOpened(newVal, oldVal) {
      if (newVal != false) {
        this.disableClick = true;
      } else {
        this.disableClick = false;
      }
      if (newVal.opened === true) {
        this.openSmallPopup(newVal.step)
      }
    }
  },
  data() {
    return {
      renderer: null,
      orbitControls: null,
      overlayClickedCounter: 0,
      globalStorage: null,
      setSmallPopupStep: null,
      mapVisible: false,
      showElement: false,
      publicPath: process.env.BASE_URL,
      envmapPath: process.env.BASE_URL + 'glb/envmap.exr',
      popupData: {
        en: popupsEn,
        de: popupsDe,
        cn: popupsCn,
        tr: popupsTr,
        ja: popupsJa
      },

      currentPopupModel: null,
      startCoords: null,
      targetCoords: null,
      camera: null,
      cameraControls: null,
      animationType: 'default',
      shortcutMenu: null,
      mixers: [],
      mixer: null,
      models: null,
      selectedImage: null,
      mainMenuOpened: false,
      resetLaunchTimeline: false,
      smallPopup: null,
      popup_content_right_container: null,
      takeabreakElement1: null,
      takeabreakElement2: null,
      popupHeroContainer: null,
      lastLookAt: null,
      testtimeline: null,
      disableClick: false,
    }
  },
  mounted() {
    this.publicPath;
    this.envmapPath;
    this.camera;

  },
  methods: {
    getPopups() {
      const supportedLanguages = ["en", "de", "tr", "ja", "cn"]; // Liste der unterstützten Sprachen
      const currentLocale = this.$i18n.locale;
console.log(currentLocale);
      if (supportedLanguages.includes(currentLocale)) {
        return this.popupData[currentLocale];
      } else {
        return this.popupData.en; // Fallback auf Englisch
      }
    },
    initializeModels(avatarPrefix) {
      const basePath = 'glb/Character/';
      const modelTypes = ['university', 'airport', 'church'];

      this.models = {
        'mainMap': {
          url: 'glb/NRW_GB_modelling.glb',
          mixer: null,
          animation: null,
        },
        ...modelTypes.reduce((acc, type) => {
          acc[type + 'Char'] = {
            url: `${basePath}${avatarPrefix}_${type}.glb`,
            mixer: null,
            animation: null,
          };
          return acc;
        }, {}),
      };
    },
    setCamera() {
      this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 5000);
      this.camera.position.set(4, 10, 18);
    },
    setCameraControls() {
      this.cameraControls = new CameraControls(this.camera, this.renderer);
      this.cameraControls.setTarget(0, 0, 0); // Zielpunkt der OrbitControls
      this.cameraControls.enableDamping = true;   //damping
      this.cameraControls.dampingFactor = 0.25;   //damping inertia
      // this.cameraControls.enablePan = false;
      this.cameraControls.mouseButtons.right = CameraControls.ACTION.NONE;
      this.cameraControls.enableZoom = true;      //Zooming
      this.cameraControls.autoRotate = false;       // enable rotation
      this.cameraControls.maxPolarAngle = Math.PI / 2.4; // Limit angle of visibility
      this.cameraControls.minDistance = 10; // Beispielwert, passen Sie ihn an Ihre Bedürfnisse an
      this.cameraControls.maxDistance = 20; // Beispielwert, passen Sie ihn an Ihre Bedürfnisse an
      this.cameraControls.maxAzimuthAngle = Math.PI / 2;
      this.cameraControls.minAzimuthAngle = Math.PI / -2;
    },
    setOrbitControls() {
      this.orbitControls = new OrbitControls(this.camera, this.renderer);
      this.orbitControls.target.set(0, 0, 0); // Zielpunkt der OrbitControls
      this.orbitControls.enableDamping = true;   //damping
      this.orbitControls.dampingFactor = 0.25;   //damping inertia
      this.orbitControls.enablePan = false;
      this.orbitControls.enableZoom = true;      //Zooming
      this.orbitControls.autoRotate = false;       // enable rotation
      this.orbitControls.maxPolarAngle = Math.PI / 2.4; // Limit angle of visibility
      this.orbitControls.minDistance = 10; // Beispielwert, passen Sie ihn an Ihre Bedürfnisse an
      this.orbitControls.maxDistance = 20; // Beispielwert, passen Sie ihn an Ihre Bedürfnisse an
      this.orbitControls.maxAzimuthAngle = Math.PI / 2;
      this.orbitControls.minAzimuthAngle = Math.PI / -2;
    },
    getAvatar(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
    closemenu() {
      if (this.$refs.shortcutMenu.classList.contains('open')) {
        this.$emit('toggleBackdrop', {backdrop: false, showMenu: false});
        // Close the menu
        this.$refs.shortcutMenu.classList.remove('open');
        this.$refs.shortcutMenu.classList.remove('opened'); // Ensure 'opened' is removed as well

        gsap.to(('#testo #Gruppe_7895'), {display: "none", autoAlpha: 0})
        gsap.to(('#testo #Gruppe_6076'), {display: "block", autoAlpha: 1})

        gsap.to(this.$refs.shortcutMenu, {
          y: "-10%",
          autoAlpha: 0,
          duration: 0.5,
          zIndex: -1,
          onComplete: () => {
            this.$refs.shortcutMenu.classList.remove('open');
          }
        });

        // Timeout for smoother animation (optional)
        setTimeout(() => {
          this.$refs.shortcutMenu.classList.remove("opened"); // Redundant but harmless
        }, 500);
      }
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    toggleMenu() {

      // Close
      // Check if the menu has the "open" class
      if (this.$refs.shortcutMenu.classList.contains('open')) {
        this.$emit('toggleBackdrop', {backdrop: false, showMenu: false});
        // Close the menu
        this.$refs.shortcutMenu.classList.remove('open');
        this.$refs.shortcutMenu.classList.remove('opened'); // Ensure 'opened' is removed as well

        gsap.to(('#testo #Gruppe_7895'), {display: "none", autoAlpha: 0})
        gsap.to(('#testo #Gruppe_6076'), {display: "block", autoAlpha: 1})
        gsap.to(this.$refs.shortcutMenu, {
          y: "-20%",
          autoAlpha: 0,
          duration: 0.5,
          zIndex: -1,
          onComplete: () => {
            this.$refs.shortcutMenu.classList.remove('open');
          }
        });

        // Timeout for smoother animation (optional)
        setTimeout(() => {
          this.$refs.shortcutMenu.classList.remove("opened"); // Redundant but harmless
        }, 500);
      } else {
        this.$emit('toggleBackdrop', {backdrop: true, showMenu: true});
        // Open the menu
        this.$refs.shortcutMenu.classList.add("open");
        this.$refs.shortcutMenu.classList.add('opened');
        gsap.to(('#testo #Gruppe_6076'), {display: "none", autoAlpha: 0})
        gsap.to(('#testo #Gruppe_7895'), {
          display: "block",
          autoAlpha: 1,


        })
        gsap.to(this.$refs.shortcutMenu, {
          y: "0%",
          autoAlpha: 1,
          display: "block",
          duration: 0.5,
          zIndex: 9999,
        });
      }
    },
    onLabelClick(object) {
      this.openPopup(object.name);
    },
    closePopup(direction) {

      this.closeOverlay();
      this.closemenu();
      this.currentPopupModel = null;
      this.startAnimation(direction);
      this.$emit('toggleBackdrop', {backdrop: false, showMenu: false});

      const store = useClickedStore();
      if (store.count == 4) {
        setTimeout(() => {
          this.openSmallPopup('launchTimeStep1')
        }, 1500)

      }
      if (store.count == 8) {
        setTimeout(() => {
          this.openSmallPopup('eventStep1')
        }, 1500)
      }
    },
    closeOverlay(event) {
      const closeOverlay = async (event) => {
        this.sidebarOpened = false;
        this.$emit('toggleBackdrop', {backdrop: false, showMenu: false});
        this.$emit('toggleSmallPopup', false);
        this.setSmallPopupStep = null;

        const overlays = document.querySelectorAll('.overlay');


        // Durchläuft alle gefundenen Overlays und setzt deren Anzeige auf 'none'
        overlays.forEach((popup) => {

          //gsap.killTweensOf(popup);
          // popup.style.display = 'none';
          gsap.to(popup, {
            opacity: 0,
            duration: 0.3,
            onComplete: () => {
              popup.style.display = "none";
            }
          })

          gsap.to(('.outline-wrapper'), {
            onComplete: () => {
              document.querySelectorAll('.outline-wrapper').forEach(function (element) {
                element.classList.add('animated');
              });

            }
          })
        });


        if (this.targetCoords !== undefined && this.startCoords !== undefined) {
          this.startCoords = {
            x: 4,
            y: 10,
            z: 18 // Zoomt um 10 Einheiten näher an das Objekt
          };


          if (this.lastLookAt != null) {

            this.cameraControls.setPosition(4, 10, 18, true);
            await this.cameraControls.setTarget(
                0, 0, 0, true
            );
            this.orbitControls.update();
          }
        }
      }
      closeOverlay(event);
    },
    initThreeJS() {
      // let avatar;
      const exrLoader = new EXRLoader();// eslint-disable-line no-unused-vars
      const textureLoader = new CubeTextureLoader(); // eslint-disable-line no-unused-vars
      const manager = new THREE.LoadingManager();

      const raycaster = new THREE.Raycaster();
      const mouse = new THREE.Vector2();

      const validNames = [
        "Windrad_Gerüst002", "Fabrik013", "Flughafen", "Businessviertel005",
        "Baustelle", "Einkaufszentrum", "Universitaet", "Multikulturelles_ViertelMAIN",
        "Forschungszentrum", "StartUpHub", "SchiffshafenMAIN", "Bahnhof004",
        "Energielandschaft", "Fussballstadion007", "Museum",
        "Koelner_Dom", "Windrad_Gruppe_animiert", "See",
      ];

      let waterMaterial = null;
      let shadowMapSize = null;
      let container = document.getElementById('three-container')

      gsap.to(".circle-container", {
        duration: 10,
        rotation: 360,
        repeat: -1,
        ease: "none"
      });
      gsap.to(".icon", {
        duration: 10,
        rotation: -360,
        repeat: -1,
        ease: "none",
        transformOrigin: "50% 50%"
      });


      // FIXME Quickmenu Eventlistener in vue einbauen
      const quickmenu = document.querySelector("header .openmenu");

      quickmenu.addEventListener("click", () => {
        this.toggleMenu();
      })


      manager.onStart = function (url, itemsLoaded, itemsTotal) {

      };

      manager.onProgress = function (url, itemsLoaded, itemsTotal) {
        const progress = (itemsLoaded / itemsTotal) * 100;

        document.getElementById('loader').innerText = `${progress.toFixed(0)}%`;
      };

      manager.onLoad = function () {
        fadeOut();
      };


      manager.onError = function (url) { // eslint-disable-line no-unused-vars
      };


// Überprüfen, ob der Benutzer ein mobiles Gerät verwendet
      const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);

// Erstellen Sie den Renderer mit Antialiasing deaktiviert, wenn es ein mobiles Gerät ist
      const renderer = new THREE.WebGLRenderer({antialias: !isMobileDevice, alpha: true});
      const composer = new EffectComposer(renderer);


      const w = window.innerWidth * 1 || 1;
      const h = window.innerHeight * 1 || 1;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);

      if (isMobileDevice) {
        composer.setSize(w, h);
      } else {
        composer.setSize(w, h);
      }

      composer.setPixelRatio(ratio);

      renderer.shadowMap.enabled = true;
      renderer.setPixelRatio(ratio);
      renderer.setSize(w, h);
      renderer.gammaFactor = 2.2;
      renderer.gammaOutput = true;
      renderer.gammaInput = true;
      renderer.gammaFactor = 2.2;
      renderer.domElement.id = '3dmap';
      this.renderer = renderer.domElement;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;


      const pmremGenerator = new PMREMGenerator(renderer); // eslint-disable-line no-unused-vars


      this.setCamera();
      this.setCameraControls()
      this.setOrbitControls();


      const labelRenderer = new CSS2DRenderer();
      labelRenderer.setSize(container.clientWidth, container.clientHeight);
      labelRenderer.domElement.style.position = 'absolute';
      labelRenderer.domElement.style.top = '0px';
      labelRenderer.domElement.style = 'pointer-events:none';
      labelRenderer.domElement.style = 'overflow:hidden';
      container.appendChild(labelRenderer.domElement);

      const scene = new THREE.Scene();

      composer.addPass(new RenderPass(scene, this.camera));

      const smaaPass = new SMAAPass(window.innerWidth, window.innerHeight);
      composer.addPass(smaaPass);

      // const fxaaPass = new ShaderPass(FXAAShader);
      // fxaaPass.uniforms['resolution'].value.set(1 / window.innerWidth, 1 / window.innerHeight);
      // composer.addPass(fxaaPass);


// Stellen Sie sicher, dass der letzte Pass in der Kette das Rendering auf dem Bildschirm ausführt


      const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader);
      composer.addPass(gammaCorrectionPass);


      const outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), scene, this.camera);
      composer.addPass(outlinePass);

// Konfigurieren des Outline-Effekts
      outlinePass.edgeStrength = 2;    // Intensität der Outline
      outlinePass.edgeGlow = 0.5;      // Weichheit der Outline
      outlinePass.edgeThickness = 1;   // Dicke der Outline
      outlinePass.visibleEdgeColor.set('#FDBE1F'); // Farbe der Outline
      outlinePass.hiddenEdgeColor.set('#FDBE1F'); // Farbe der Outline, wenn hinter einem Objekt


      // fxaaPass.renderToScreen = !isMobileDevice;
      // smaaPass.renderToScreen = !isMobileDevice;

      const ambientLight = new THREE.AmbientLight("#F3FECD", 0.9);
      scene.add(ambientLight);

      const hemiLight = new THREE.HemisphereLight(0xDD9836, 0x1DB9FC, 0.66);
      hemiLight.position.set(0, 50, 0);
      scene.add(hemiLight);

      const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 5.45);
      directionalLight.position.set(13.1, 25.4, -22.5);
      directionalLight.castShadow = true;


      const directionalLightOpposite = new THREE.DirectionalLight(0xFFFFFF, 1.15);
      directionalLightOpposite.position.set(0.8, 0.8, -9);
      directionalLightOpposite.castShadow = false;


      if (isMobileDevice) {
        shadowMapSize = 1024;
      } else {
        shadowMapSize = 2048;
      }

      directionalLight.shadow.mapSize.width = shadowMapSize;
      directionalLight.shadow.mapSize.height = shadowMapSize;
      directionalLight.shadow.camera.near = 2;
      directionalLight.shadow.camera.far = 80;
      directionalLight.shadow.camera.top = 20;
      directionalLight.shadow.camera.bottom = -20;
      directionalLight.shadow.camera.left = -20;
      directionalLight.shadow.camera.right = 20;
      directionalLight.shadow.bias = -0.001;


      scene.add(directionalLight);
      scene.add(directionalLightOpposite);


// Erstelle ein neues GUI-Objekt

      /*
      var gui = new GUI();

      // Füge der GUI einen Ordner für das directionalLight hinzu
      var lightFolder = gui.addFolder('Directional Light');
      var lightFolderOpposite = gui.addFolder('Directional Light Opposite');
      var lightFolderAmbient = gui.addFolder('Ambient Light');
      var lightFolderHemi = gui.addFolder('Hemisphere Light');
      var toneMappingFolder = gui.addFolder('Tone Mapping');
      var cameraFolder = gui.addFolder('Kameraeinstellungen');

      cameraFolder.add(controls, 'maxDistance', 0, 1000, 1).name('Maximaler Zoom');
      cameraFolder.add(controls, 'minDistance', 0, 1000, 1).name('Minimaler Zoom');

      // Für die Beschränkung der X- und Y-Achse musst du die Logik anpassen, basierend darauf, wie du die Beschränkungen definieren möchtest
      // Hier ein Beispiel für die Anpassung der Neigungswinkel
      cameraFolder.add(controls, 'maxPolarAngle', 0, Math.PI).name('Max Y-Achsen-Neigung');
      cameraFolder.add(controls, 'minPolarAngle', 0, Math.PI).name('Min Y-Achsen-Neigung');

      cameraFolder.open(); // Öffnet das Kamera-Folder im GUI automatisch



      lightFolderAmbient.addColor(new Object({color: ambientLight.color.getHex()}), 'color').onChange(function (value) {
          ambientLight.color.setHex(value);
      });
      lightFolderAmbient.add(ambientLight, 'intensity', 0, 10, 0.01);

      // Ordner und Steuerelemente für hemiLight hinzufügen
      lightFolderHemi.addColor(new Object({skyColor: hemiLight.color.getHex()}), 'skyColor').name('Sky Color').onChange(function (value) {
          hemiLight.color.setHex(value);
      });
      lightFolderHemi.addColor(new Object({groundColor: hemiLight.groundColor.getHex()}), 'groundColor').name('Ground Color').onChange(function (value) {
          hemiLight.groundColor.setHex(value);
      });
      lightFolderHemi.add(hemiLight, 'intensity', 0, 10, 0.01);

      // Füge Steuerelemente für die Farbe hinzu
      lightFolder.addColor(new Object({color: directionalLight.color.getHex()}), 'color').onChange(function (value) {
          directionalLight.color.setHex(value);
      });

      // Füge Steuerelemente für die Intensität hinzu
      lightFolder.add(directionalLight, 'intensity', 0, 10, 0.01);

      // Füge Steuerelemente für die Position hinzu
      lightFolder.add(directionalLight.position, 'x', -50, 50, 0.1);
      lightFolder.add(directionalLight.position, 'y', -50, 50, 0.1);
      lightFolder.add(directionalLight.position, 'z', -50, 50, 0.1);


      // Füge Steuerelemente für die Farbe hinzu
      lightFolderOpposite.addColor(new Object({color: directionalLightOpposite.color.getHex()}), 'color').onChange(function (value) {
          directionalLightOpposite.color.setHex(value);
      });

      // Füge Steuerelemente für die Intensität hinzu
      lightFolderOpposite.add(directionalLightOpposite, 'intensity', 0, 10, 0.01);

      // Füge Steuerelemente für die Position hinzu
      lightFolderOpposite.add(directionalLightOpposite.position, 'x', -50, 50, 0.1);
      lightFolderOpposite.add(directionalLightOpposite.position, 'y', -50, 50, 0.1);
      lightFolderOpposite.add(directionalLightOpposite.position, 'z', -50, 50, 0.1);


      // Zeige den Ordner standardmäßig an
      lightFolder.open();
      lightFolderOpposite.open();
      lightFolderAmbient.open();
      lightFolderHemi.open();
      */

      const interactionManager = new InteractionManager(
          renderer,
          this.camera,
          renderer.domElement
      );

      this.camera.lookAt(new THREE.Vector3(0, 0, 0)); // Blick auf den Ursprung (oder ein anderes Ziel)


      renderer.domElement.addEventListener('mousemove', onMouseMove);


// Erstellen Sie eine PlaneGeometry für die Ebene
      const planeGeometry = new THREE.PlaneGeometry(100, 100); // Die Größe kann angepasst werden

// Erstellen Sie ein ShadowMaterial
      const shadowMaterial = new THREE.ShadowMaterial({
        opacity: 0.3 // vollständig transparent
      });

// Erstellen Sie ein Mesh aus der Geometrie und dem Material
      const planeMesh = new THREE.Mesh(planeGeometry, shadowMaterial);

// Stellen Sie die Position und Ausrichtung der Ebene ein
      planeMesh.rotation.x = -Math.PI / 2; // Dreht die Ebene, um sie horizontal auszurichten
      planeMesh.position.y = -10; // Setzen Sie die y-Position (Höhe) so ein, dass sie unter Ihrem Modell liegt

// Aktivieren Sie Schattenempfang auf der Ebene
      planeMesh.receiveShadow = true;

// Fügen Sie die Ebene zur Szene hinzu
      scene.add(planeMesh);


// Erstelle ein Container-Element für die Steuerung
      const controlsContainer = document.createElement('div');
      controlsContainer.style.position = 'absolute';
      controlsContainer.style.top = '10px';
      controlsContainer.style.left = '10px';
      document.body.appendChild(controlsContainer);


      let clock = new THREE.Clock();

// Starte die Animationsschleife


      function onMouseMove(event) {
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      }


      const fadeOut = () => {
        var element = document.getElementById('preloader');
        let tl = gsap.timeline();


        // Füge die CSS-Klasse hinzu, um das Ausblenden zu initiieren
        element.classList.add('fade-out');

        // Warte auf das Ende der Transition und setze die Opacity auf 0
        setTimeout(function () {
          element.style.opacity = 0;
          setTimeout(function () {
            element.remove();
            var element2 = document.getElementsByClassName('dynamicspeechbubble');
            tl.fromTo(element2, {display: "none", opacity: 1, y: 200}, {display: "flex", opacity: 1, y: 0})

          }, 1000); // Hier 1000 steht für die Dauer der Transition in Millisekunden

        }, 1000);
      }


      initScene();


      const loader = new GLTFLoader(manager);

      const onLoadModel = (modelKey, gltf) => {
        const modelInfo = this.models[modelKey];
        const model = gltf.scene;


        model.traverse((node) => {

          if (node.isMesh && node.name == "CircleDom") {

            node.material.transparent = true; // Transparenz aktivieren
            node.material.opacity = 0.7; // Opazität setzen (0.0 - vollständig transparent, 1.0 - vollständig undurchsichtig)
          }
        });

        // model.visible = (modelKey == 'churchChar') ? true : false;
        model.visible = false;
        scene.add(model);
        if (gltf.animations && gltf.animations.length > 0) {
          this.mixer = new THREE.AnimationMixer(model);
          modelInfo.mixer = this.mixer;

          // Initialisiere modelInfo.animation als Array
          modelInfo.animation = [];

          // Füge gltf.animations[0] zum Array hinzu
          modelInfo.animation.push(gltf.animations[0]);

          // Überprüfen, ob eine Animation mit dem Namen "action" existiert
          const actionAnimation = gltf.animations.find(animation => animation.name === "Action" || animation.name === "Action.002" || animation.name === "Action.001");

          // Falls die Animation "action" existiert, füge sie dem Array hinzu
          if (actionAnimation) {

            modelInfo.animation.push(actionAnimation);
          }

          this.mixers.push(this.mixer);
        }

        if (modelKey == "churchChar") {
          startAnimationWithVisibility(modelKey);
        }
      }

      Object.keys(this.models).forEach((modelKey) => {
        const modelInfo = this.models[modelKey];
        if (modelKey == 'mainMap') {
          loader.load(modelInfo.url + '?' + Date.now(), gltf => onLoad(gltf, this.envmapPath),
              null,
              onError);
        } else {
          loader.load(modelInfo.url + '?' + Date.now(),
              gltf => onLoadModel(modelKey, gltf),
              null,
              onError);
        }
      });


// Funktion zum Aus- und Einblenden der Modelle und Starten der Animation
      const startAnimationWithVisibility = (modelKey) => {

        const callback = () => {
          setTimeout(() => {
            this.startAnimation(modelKey);
          }, 500);

        };
        // Alle Modelle ausblenden
        Object.keys(this.models).forEach(key => {
          const modelInfo = this.models[key];
          if (modelInfo.mixer && modelInfo.animation) {
            const model = modelInfo.mixer.getRoot();
            model.visible = false; // Modell ausblenden
          }
        });

        // Gewünschtes Modell einblenden


        this.prepareAnimation(modelKey, callback); // Verwende die bereits definierte startAnimation Funktion
      }


      function initScene() {
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        renderer.setSize(container.clientWidth, container.clientHeight);
        container.appendChild(renderer.domElement);
      }

      this.targetCoords;
      this.startCoords;

      let currentHoveredObject = null; // Variable um das aktuelle gehoverte Objekt zu speichern

      const removeLabelFromObject = (object) => {
        if (object && object.children.length) {
          const labelIndex = object.children.findIndex(child => child instanceof CSS2DObject);
          if (labelIndex !== -1) {
            object.remove(object.children[labelIndex]); // Entfernt das Label
          }
        }
      }

      const createLabelForObject = (object) => {
        const labelDiv = document.createElement('div');
        labelDiv.className = 'maplabels';
        const labelText = document.createElement('p');
        const translations = {
          Fabrik013: {
            en: "Factory",
            de: "Fabrik",
            tr: "Fabrika",
            cn: "工厂",
            ja: "工場"
          },
          Einkaufszentrum: {
            en: "Shopping center",
            de: "Einkaufszentrum",
            tr: "Alışveriş merkezi",
            cn: "购物中心",
            ja: "ショッピングセンター"
          },
          Businessviertel005: {
            en: "Companies",
            de: "Unternehmen",
            tr: "Şirketler",
            cn: "该公司",
            ja: "ビジネス"
          },
          Multikulturelles_ViertelMAIN: {
            en: "Multicultural quarter",
            de: "Multikulturelle Viertel",
            tr: "Çok kültürlü mahalle",
            cn: "多文化地区",
            ja: "多種多様な文化"
          },
          Baustelle: {
            en: "Investment location",
            de: "Investitionsstandort",
            tr: "Yatırım yeri",
            cn: "投资地点",
            ja: "投資拠点"
          },
          Universitaet: {
            en: "University",
            de: "Universität",
            tr: "Üniversite",
            cn: "大学",
            ja: "大学"
          },
          Forschungszentrum: {
            en: "Research center",
            de: "Forschungszentrum",
            tr: "Araştırma merkezi",
            cn: "研究",
            ja: "研究"
          },
          StartUpHub: {
            en: "Startup-Hub",
            de: "Startup-Hub",
            tr: "Startup Merkezi",
            cn: "创业中心",
            ja: "スタートアップ・ハブ"
          },
          SchiffshafenMAIN: {
            en: "Port",
            de: "Hafen",
            tr: "Liman",
            cn: "港口",
            ja: "港"
          },
          Flughafen: {
            en: "Airport",
            de: "Flughafen",
            tr: "Havalimanı",
            cn: "机场",
            ja: "空港"
          },
          Bahnhof004: {
            en: "Train station",
            de: "Bahnhof",
            tr: "Tren istasyonu",
            cn: "火车站",
            ja: "駅"
          },
          Windrad_Gruppe_animiert: {
            en: "Energy landscape",
            de: "Energielandschaft",
            tr: "Enerji manzarası",
            cn: "能源格局",
            ja: "エネルギー分野"
          },
          See: {
            en: "Forest and nature",
            de: "Wald und Natur",
            tr: "Orman ve doğa",
            cn: "森林与自然",
            ja: "森と自然"
          },
          Fussballstadion007: {
            en: "Soccer stadium",
            de: "Fußballstadion",
            tr: "Futbol stadyumu",
            cn: "足球场",
            ja: "サッカースタジアム"
          },
          Museum: {
            en: "Museum",
            de: "Museum",
            tr: "Müze",
            cn: "博物馆",
            ja: "美術・博物館"
          },
          Koelner_Dom: {
            en: "Cologne Cathedral",
            de: "Kölner Dom",
            tr: "Köln Katedrali",
            cn: "科隆大教堂",
            ja: "ケルン大聖堂"
          }
        };

        switch (object.name) {

          default:
            labelText.textContent = translations[object.name][this.$i18n.locale] || translations[object.name].en; // Fallback auf Englisch
            break;
        }

        labelDiv.appendChild(labelText);

        const label = new CSS2DObject(labelDiv);
        // label.position.copy(object.position);
        if (object.name == 'Bahnhof004') {
          label.position.set(5, 1, 0)
        } else {
          label.position.set(0, 0, 0)
        }
        object.add(label); // Fügen Sie das Label zum Objekt hinzu
        // Click-Event-Handler hinzufügen
      }
      const onObjectClicked = async (object) => {
        const cube = object;

        this.startCoords = {
          x: this.camera.position.x,
          y: this.camera.position.y,
          z: this.camera.position.z
        };

        // Zielwerte für die Animation
        this.targetCoords = {
          x: object.name === "Windrad_Gruppe_animiert" ? cube.parent.position.x : cube.position.x,
          y: object.name === "Windrad_Gruppe_animiert" ? cube.parent.position.y : cube.position.y,
          z: object.name === "Windrad_Gruppe_animiert" ? cube.parent.position.z : cube.position.z
        };

        this.lastLookAt = cube.position;

        this.cameraControls.setPosition(this.startCoords.x + 1, this.startCoords.y - 2, 5, true);
        await this.cameraControls.setTarget(
            this.targetCoords.x, this.targetCoords.y, this.targetCoords.z, true
        );
        this.onLabelClick(cube);
      }
      const timeline = gsap.timeline({
        onComplete: () => {
          outlinePass.selectedObjects = [];
        }
      });
      var currentChild = null;
      const onLoad = (gltf, envMapPath) => {
        const model = gltf.scene;
        const meshUUID = 'Water';
        let targetMesh;
        // const targetMeshName = 'Cube042'; // Der Name des Meshs, dem die Umgebungsmap zugewiesen werden soll
        let targetMeshEXR;

        var selectedObjects = [];
        model.traverse((child) => {
          if (validNames.includes(child.name)) {
            selectedObjects.push(child);
          }

          if (child.isMesh) {
            child.addEventListener("click", (event) => {
              event.stopPropagation();
            });
            interactionManager.add(child);
            child.castShadow = true; // Standardmäßig erlauben wir allen Meshes, Schatten zu werfen
            child.receiveShadow = true;
            if (child.material.map) {
              child.material.map.anisotropy = 16;
            }
            if (child.name === "Plane005") {
              // Verbiete diesem speziellen Mesh, Schatten zu werfen
              child.castShadow = false;
            }
            if (child.name === "Cube061") {
              targetMeshEXR = child;
            }


          }
          if (child.isMesh && child.material.name === meshUUID) {
            waterMaterial = child;
          }
          if (child.name == "lpMaleG002") {

          }
        });

        outlinePass.selectedObjects = [];
        selectedObjects = this.shuffleArray(selectedObjects);

        selectedObjects.forEach((obj, index) => {
          timeline.to({}, { // Ein leeres Objekt als Ziel verwenden
            onStart: () => {
              createLabelForObject(obj)
              outlinePass.selectedObjects.push(obj);
              currentChild = obj;
            },
            onUpdate: () => {
              outlinePass.selectedObjects = [...outlinePass.selectedObjects]; // Force update
              gsap.to(".maplabels", {
                autoAlpha: 1
              })
            },
            onComplete: () => {
              gsap.to(".maplabels", {
                autoAlpha: 0,
                onComplete: () => {
                  removeLabelFromObject(obj);
                  outlinePass.selectedObjects = [];
                }
              })

            },
            delay: 1, // Verzögerung für den Stagger-Effekt
            duration: 1
          });
        });

        if (gltf.animations && gltf.animations.length > 0) {
          this.mixer = new THREE.AnimationMixer(model);
          this.mixers.push(this.mixer); // Füge den Mixer zum Array hinzu, damit er in der Animationsfunktion aktualisiert wird
          let counter = 0;
          gltf.animations.forEach((clip) => {
            counter++;
            if (counter <= 36) {
              this.mixer.clipAction(clip).play();
            }
            //
          });
        }

        if (targetMeshEXR) {
          // Schritt 2: EXR-Umgebungsmap laden
          exrLoader.load(envMapPath, (texture) => { // Arrow-Funktion verwendet
            const envMap = pmremGenerator.fromEquirectangular(texture).texture;
            targetMeshEXR.material.envMap = envMap;
            targetMeshEXR.material.needsUpdate = true;
          });
        }


        scene.add(model);

      }


      let timeout = null;
      let cssInserted = false;

      function insertCSSRule() {
        if (!cssInserted) {
          timeline.kill();
          removeLabelFromObject(currentChild);
          const style = document.createElement('style');
          style.type = 'text/css';
          style.innerHTML = `.maplabels {
opacity: 1 !important;
}`;
          document.head.appendChild(style);
          cssInserted = true; // Setze die Variable auf true, nachdem das CSS eingefügt wurde
        }
      }

      const closeoverlay = document.querySelectorAll(".closeoverlay, .getGuideStep");

      closeoverlay.forEach(element => {
        element.addEventListener("click", () => {
          insertCSSRule();
        })
      });


      window.addEventListener('mousemove', (event) => {
        var element = document.querySelector('.three');
        var element2 = document.querySelector('footer .dynamicspeechbubble');
        if (element && !element.classList.contains('backdrop') && window.getComputedStyle(element2).display === 'none') {
          if (!timeout) {
            timeout = setTimeout(() => {
              timeout = null;
              // Update mouse position
              mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
              mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

              // Update raycaster
              raycaster.setFromCamera(mouse, this.camera);

              // Check for intersections
              const intersects = raycaster.intersectObjects(scene.children, true);

              if (intersects.length > 0) {

                const selectedObject = intersects[0].object;

                let targetObject = selectedObject; // Setze standardmäßig das ausgewählte Objekt als Zielobjekt

                // Überprüfen, ob der Parent-Name gültig ist, falls vorhanden
                if (selectedObject.parent && validNames.includes(selectedObject.parent.name)) {
                  if (!outlinePass.selectedObjects.includes(selectedObject)) {

                    outlinePass.selectedObjects = [selectedObject.parent];
                  }
                  targetObject = selectedObject.parent;
                } else if (!validNames.includes(selectedObject.name)) {
                  // Wenn weder das Objekt noch der Parent in validNames sind, entferne das Label und ignoriere den Treffer
                  if (currentHoveredObject) {
                    outlinePass.selectedObjects = []; // Leeren der Auswahl, wenn nichts gehovered wird
                    removeLabelFromObject(currentHoveredObject);
                    currentHoveredObject = null; // Setze currentHoveredObject zurück
                  }
                  return;
                }

                // Überprüfe, ob das aktuelle gehoverte Objekt aktualisiert werden muss
                if (currentHoveredObject !== targetObject) {
                  if (currentHoveredObject) {
                    outlinePass.selectedObjects = []; // Leeren der Auswahl, wenn nichts gehovered wird
                    removeLabelFromObject(currentHoveredObject); // Entferne das Label vom vorherigen Objekt
                  }
                  createLabelForObject(targetObject);
                  currentHoveredObject = targetObject; // Speichere das neue gehoverte Objekt

                }
              } else {

                if (currentHoveredObject) {
                  outlinePass.selectedObjects = []; // Leeren der Auswahl, wenn nichts gehovered wird
                  removeLabelFromObject(currentHoveredObject);
                  currentHoveredObject = null; // Setze currentHoveredObject zurück, wenn kein Objekt mehr gehovert wird
                }
              }
            }, 25); // Die Verzögerung auf 25 Millisekunden setzen
          }

        }
      });
      window.addEventListener('click', (event) => {
        var element = document.querySelector('.three');
        var element2 = document.querySelector('footer .dynamicspeechbubble');
        if (element && !element.classList.contains('backdrop') && window.getComputedStyle(element2).display === 'none') {
          mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
          mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

          raycaster.setFromCamera(mouse, this.camera);

          const intersects = raycaster.intersectObjects(scene.children, true);
          if (intersects.length > 0) {
            const clickedObject = intersects[0].object;
            let targetObject = clickedObject.parent && validNames.includes(clickedObject.parent.name) ? clickedObject.parent : clickedObject;

            if (validNames.includes(targetObject.name)) {
              onObjectClicked(targetObject);
            }
          }
        }
      });

      function onError(err) {
        console.error('Error loading GLB file:', err);
      }


      let normalMapUpdateCounter = 0;
      const normalMapUpdateFrequency = 10; // Update alle 10 Frames

      const animate = () => {
        requestAnimationFrame(animate); // Plant die nächste Ausführung dieser Funktion

        // Update-Zeit berechnen
        const delta = clock.getDelta(); // Berechne die Zeit seit dem letzten Frame

        // Aktualisiere Wassermaterial-Offset nur bei Bedarf
        if (normalMapUpdateCounter % normalMapUpdateFrequency === 0) {
          if (waterMaterial && waterMaterial.material.normalMap) {
            waterMaterial.material.normalMap.offset.y -= 0.003;
          }
        }
        normalMapUpdateCounter++;

        // Aktualisiere Kamera-Kontrollen
        this.cameraControls.update(delta);

        // Aktualisiere AnimationMixer-Instanzen
        for (const mixer of this.mixers) {
          mixer.update(delta);
        }

        // Führe zusätzliche Updates oder Berechnungen durch, z.B. TWEEN-Animationen oder Interaktions-Management
        // TWEEN.update(); // Aktualisiere TWEEN-Animationen
        interactionManager.update(); // Aktualisiere Interaktionen

        // Rendere die Szene mit den aktuellen Änderungen
        composer.render(); // Verwenden Sie den Composer zum Rendern

        // Wenn du einen zweiten Renderer hast, wie z.B. einen CSS2DRenderer für Labels, führe diesen nach dem Hauptrenderer aus
        labelRenderer.render(scene, this.camera);
      };

      this.$nextTick(() => {
        animate();
      });

    },
    startAnimation(modelKey) {

      const targetModelInfo = this.models[modelKey];
// Gewünschtes Modell einblenden und Animation vorbereiten
      if (targetModelInfo.mixer && targetModelInfo.animation) {
        if (Array.isArray(targetModelInfo.animation)) {
          targetModelInfo.animation.forEach(animationClip => {
            const action = targetModelInfo.mixer.clipAction(animationClip);
            action.paused = false;
            action.play()
          });
        } else {
          const action = targetModelInfo.mixer.clipAction(targetModelInfo.animation);

          action.paused = false;
          action.play()
        }

        //
      }
    },
    prepareAnimation(modelKey, callback) {
// Zugriff auf das gewünschte Modell einmal speichern
      const targetModelInfo = this.models[modelKey];


// Alle Modelle ausblenden, außer dem gewählten Modell
      Object.values(this.models).forEach(modelInfo => {


        const model = modelInfo.mixer?.getRoot();
        if (model) model.visible = false;
      });

// Gewünschtes Modell einblenden und Animation vorbereiten
      if (targetModelInfo.mixer && targetModelInfo.animation) {
        const modelToShow = targetModelInfo.mixer.getRoot();

        modelToShow.children.forEach(child => {
          if (child.name === "CircleDom" || child.name === "CircleFlughafen" || child.name === "CircleUni") {
            child.material.transparent = true; // Transparenz aktivieren
            child.material.opacity = 0.7; // Opazität setzen (0.0 - vollständig transparent, 1.0 - vollständig undurchsichtig)
          }
        });

        modelToShow.visible = true;

        if (Array.isArray(targetModelInfo.animation)) {
          targetModelInfo.animation.forEach(animationClip => {
            const action = targetModelInfo.mixer.clipAction(animationClip);
            action.setLoop(THREE.LoopOnce);
            action.clampWhenFinished = true;

            action.play(); // Starte die Animation
            action.paused = true; // Pausiere die Animation sofort
            action.time = 0.001; // Setze die Zeit auf 0.001 Sekunden
          });
        } else {
          const action = targetModelInfo.mixer.clipAction(targetModelInfo.animation);
          action.setLoop(THREE.LoopOnce);
          action.clampWhenFinished = true;

          action.play(); // Starte die Animation
          action.paused = true; // Pausiere die Animation sofort
          action.time = 0.001; // Setze die Zeit auf 0.001 Sekunden
        }

        //

        // Rufe die Rückruffunktion auf, sobald die Animation vorbereitet ist
        if (callback) {
          callback();
        }
      }
    },
    openPopup(popupId) {
      this.closemenu();
      const store = useClickedStore();
      store.incrementCount();
      this.$emit('toggleBackdrop', {backdrop: true, showMenu: false});
      this.currentPopupModel = popupId; // Stelle sicher, dass du denselben Zustandsnamen verwendest wie in deinem Template
    },
    findPopupIndexById(popupId) {
      let popups = this.getPopups();
      return popups.findIndex(popup => popup.id === popupId);
    },
    nextPopup() {
      let popups = this.getPopups();
      let currentIndex = this.findPopupIndexById(this.currentPopupModel);
      let nextIndex;

// Prüfen, ob wir am Ende des Arrays sind und zum Anfang springen, falls ja
      if (currentIndex === popups.length - 1) {
        nextIndex = 0; // Zurück zum Anfang des Arrays
      } else {
        nextIndex = currentIndex + 1; // Nächster Index im Array
      }

      this.currentPopupModel = popups[nextIndex].id;
      this.animationType = 'next'; // Setze animationType auf 'next'
    },
    previousPopup() {
      let popups = this.getPopups();
      let currentIndex = this.findPopupIndexById(this.currentPopupModel);
      let prevIndex;

// Prüfen, ob wir am Anfang des Arrays sind und zum Ende springen, falls ja
      if (currentIndex === 0) {
        prevIndex = popups.length - 1; // Zum letzten Element des Arrays
      } else {
        prevIndex = currentIndex - 1; // Vorheriger Index im Array
      }

      this.currentPopupModel = popups[prevIndex].id;
      this.animationType = 'previous'; // Setze animationType auf 'previous'
    },
    openSmallPopup(data = null) {
      this.$emit('toggleBackdrop', {backdrop: true, showMenu: false});
      this.setSmallPopupStep = data;
    },
    smallPopupContentChanged(data) {
      gsap.set(this.$refs.smallPopup, {autoAlpha: 0, minHeight: 1});
      gsap.set(this.$refs.popup_wrapper__smaller, {display: "block"});
// Setze die Höhe des Containers temporär auf 'auto', um die Zielhöhe zu ermitteln
      let padding = 0;
      if (data.height != 0) {
        padding = 250;
      }
      const endHeight = data.height + padding
      const endWidth = data.width

// Setze die Höhe zurück auf den aktuellen Wert und animiere sie dann zur Zielhöhe
      gsap.to(
          this.$refs.smallPopup,
          {minHeight: endHeight, autoAlpha: 1, duration: 0.8, ease: "power1.out",}
      );

    },
    resetWebSpecial() {
      this.$emit('reset');
    },
  }
}
</script>


<template>
  <div id="threecontent">
    <div v-if="showElement" id="preloader">
      <div class="preloader_wrapper">
        <div class="circle-container">
          <svg width="350px" height="350px" viewBox="0 0 350 350">
            <defs>
              <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="80%" y2="0%">
                <stop offset="0%" style="stop-color:#FDBE1F; stop-opacity:1"/>
                <stop offset="75%" style="stop-color:#FDBE1F; stop-opacity:1"/>
                <stop offset="100%" style="stop-color:#FDBE1F; stop-opacity:1"/>
              </linearGradient>
            </defs>
            <circle cx="175" cy="175" r="175" fill="none" stroke="url(#gradientStroke)" stroke-width="4"/>
          </svg>
          <div class="icon" id="icon1"><img src="@/assets/img/loadicons/key.png"/></div>
          <div class="icon" id="icon2"><img src="@/assets/img/loadicons/laptop.png"/></div>
          <div class="icon" id="icon3"><img src="@/assets/img/loadicons/map.png"/></div>
          <div class="icon" id="icon4"><img src="@/assets/img/loadicons/phone.png"/></div>
          <div class="icon" id="icon5"><img src="@/assets/img/loadicons/passport.png"/></div>
        </div>
        <div id="loader" class="loading-text">0%</div>
      </div>
    </div>
    <div ref="shortcutMenu" id="shortcut-menu">
      <div class="shortcut-menu_wrapper">
        <h2>{{ $t('general.pointsOfInterest') }}</h2>
        <div>
          <ThreeHeader
              v-for="popup in getPopups()"
              :key="popup.id"
              :content="popup"
              @close="closePopup"
              @openPopup="openPopup"
          />
        </div>
        <div class="shortcut-menu_additionalcontent">
          <h3>{{ $t('general.shortcutMenuHeadline') }}</h3>
          <div>
            <span @click="this.closemenu();this.openSmallPopup(1)"
                  class="button">{{ $t('general.shortcutMenuHeadline') }}
            </span>
            <a target="_blank" :href="$t('general.shortcutImprintUrl')"
               class="button outline">{{ $t('general.shortcutImprint') }}</a>
            <a target="_blank" :href="$t('general.shortcutPrivacyUrl')"
               class="button outline">{{ $t('general.shortcutPrivacy') }}</a>
            <div class="popup_morecontrols">
              <div @click="resetWebSpecial">
                <div class="flex-wrapper">
                  <img ref="" class="" :src="selectedImage"/>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="icon-tabler icons-tabler-outline icon-tabler-refresh">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"/>
                    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>
                  </svg>
                </div>
                {{ $t('general.shortcutAvatar') }}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <PopupComponent
        v-for="popup in getPopups()"
        :key="popup.id"
        :content="popup"
        :isVisible="currentPopupModel === popup.id"
        :animationType="animationType"
        @animationFinished="prepareAnimation"
        @close="closePopup"
        @nextPopup="nextPopup"
        @previousPopup="previousPopup"
    />
    <SidebarOrganizer
        v-if="showElement"
        @smallPopupContentChanged="smallPopupContentChanged"
        @reset="resetWebSpecial"
        @closeOverlay="closeOverlay"
        :formData="formData"
        :mapVisible="mapVisible"
        :isVolumeMuted="isVolumeMuted"
        :sidebarOpened="isSmallPopupOpened"
        :getSmallPopupStep="setSmallPopupStep"
    >
    </SidebarOrganizer>
    <div v-show="showElement" id="three-container" class="three-js-container" ref="container"></div>
  </div>
</template>

<style lang="scss" scoped>

.popup_morecontrols {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  right: 0px;
  left: auto;
  margin-left: auto;
  top: 0px;
  box-sizing: border-box;
  z-index: 2;
  gap: 60px;
  font-size: 18px;
  flex: 0 0 100%;
  margin-top: 30px;

  @media screen and (max-width: 640px) {
    font-size: 16px;
    gap: 30px;
  }

  .flex-wrapper {
    position: relative;

    svg {
      position: absolute;
      top: 0px;
      right: 0px;
      transform: translateY(-25%) translateX(5px);
      height: auto;
      padding: 2px;
      background: #015672;
      stroke: white;
      border-radius: 50%;
      width: 20px;
      box-sizing: border-box;
    }
  }

  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: 0.3s;
    line-height: 1.2em;

    &:hover {
      transform: scale(1.1);
    }

    svg {

    }

    &:nth-of-type(2) {
      img {
        border: none;
      }
    }
  }

  img {
    width: 40px;
    height: auto;
    border: 2px solid #015672;
    border-radius: 50%;
  }

}

.three-js-container {
  width: 100vw;
  height: 100vh;

}

.popup_wrapper__smaller:has(video) {
  padding: 5px !important;
}

#sidebarpopup {
  overflow: hidden;
  max-width: 1280px;
  min-width: 50vw;
}

.takeabreakStep {
  * {
    pointer-events: none;
  }
}

.popup_content_right_container {
  display: flex;
  flex-direction: column;
}

.button {
  font-size: 22px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 1.4em;
  }
}

.helpbutton {
  margin-top: auto !important;
}

.shortcut-menu_additionalcontent {
  display: flex;
  flex-direction: column;
  margin: 20px 0 0;
  gap: 0px !important;
  flex-wrap: wrap;

  > div {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    flex-wrap: wrap;
    @media screen and (max-width: 1366px) {
      row-gap: 10px;
    }
  }

  .button {
    margin: 0px;
  }
}


</style>

<style lang="scss">
@import '../../assets/css/pages/three';

h2 {
  margin: 0 0 2rem;
}

main.three {
  background-image: url(@/assets/img/welcome_de.png), url(@/assets/img/bg.png), url(@/assets/img/bg.png), linear-gradient(180deg, rgb(233, 251, 255) 100%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgb(110, 169, 189) 0%, rgb(1, 86, 114) 40%) !important;
  background-position: left calc(60% - 75px), top -180px left 415px, bottom -410px right 260px, top, bottom !important;
  background-size: 700px, 650px, 750px, 100% 60%, 100% 100% !important;
  background-repeat: no-repeat !important;
  margin: 0px !important;
  position: relative !important;
  overflow: hidden !important;
  max-height: 100vh !important;
  @media screen and (max-width: 480px) {
    background-size: 80%, auto, 750px, 100% 60%, 100% 100% !important;
    background-position: left 10% top 20%, top -180px left 415px, bottom -410px right 260px, top, bottom !important;
  }
}

main.three.en {
  background-image: url(@/assets/img/welcome.png), url(@/assets/img/bg.png), url(@/assets/img/bg.png), linear-gradient(180deg, rgb(233, 251, 255) 100%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgb(110, 169, 189) 0%, rgb(1, 86, 114) 40%) !important;
  background-position: left calc(60% - 75px), top -180px left 415px, bottom -410px right 260px, top, bottom !important;
  background-size: 700px, 650px, 750px, 100% 60%, 100% 100% !important;
  background-repeat: no-repeat !important;
  margin: 0px !important;
  position: relative !important;
  overflow: hidden !important;
  max-height: 100vh !important;
  @media screen and (max-width: 480px) {
    background-size: 80%, auto, 750px, 100% 60%, 100% 100% !important;
    background-position: left 10% top 20%, top -180px left 415px, bottom -410px right 260px, top, bottom !important;
  }
}

main.three.tr {
  background-image: url(@/assets/img/welcome_tr.png), url(@/assets/img/bg.png), url(@/assets/img/bg.png), linear-gradient(180deg, rgb(233, 251, 255) 100%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgb(110, 169, 189) 0%, rgb(1, 86, 114) 40%) !important;
}

main.three.cn {
  background-image: url(@/assets/img/welcome_cn.png), url(@/assets/img/bg.png), url(@/assets/img/bg.png), linear-gradient(180deg, rgb(233, 251, 255) 100%, rgb(255, 255, 255) 100%), linear-gradient(90deg, rgb(110, 169, 189) 0%, rgb(1, 86, 114) 40%) !important;
}

.maplabels {
  pointer-events: none;
  opacity: 0;
  height: 6vh;
  transition: 0.3s;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }
}

.maplabels p {
  margin-top: -55px;
  padding: 5px 15px;
  background: #015672;
  font-weight: 500;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  box-sizing: border-box;
  transition: 0.3s;
  line-height: 1.875rem;

  &:hover {
    background: #FDBE1F;
    color: #000;

    &:after {
      border-top: 15px solid #FDBE1F;
    }
  }
}

.maplabels p::after {
  position: absolute;
  top: -17px;
  left: 50%;
  margin-left: -20px;
  border: 15px solid transparent;
  border-top: 15px solid #005672;
  content: "";
  transition: 0.3s;
}


</style>
